export default function (state: {customer: {title: string}}) {
  return state.customer?.title
}
